import {
  PanelContainer,
  NodePanelProps,
} from "../../lib/panel/panel-container";
import { PanelKlaviyoEvent } from "./panel-klaviyo-event";

export function KlaviyoActionNodePanel(props: NodePanelProps<any>) {
  return (
    <PanelContainer nodeProps={props}>
      <PanelKlaviyoEvent />
    </PanelContainer>
  );
}
